"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
class Teaser extends vue_property_decorator_1.Vue {
}
exports.default = Teaser;
